module.exports = __webpack_public_path__ + "img/vs-1.9cd501c8.png";